import { EventsAction, EventsActionType, EventsStore } from '../types/eventsTypes';

const initialState: EventsStore = {
  events: {
    isPending: false,
    data: [],
  },
  properties: {
    isPending: true,
    data: {},
  },
  filters: {
    category: '',
    timeline: '',
    favourites: false,
  },
  sortDesc: false,
  eventsDetails: {},
  eventTitles: {
    isPending: false,
    data: [],
  },
  eventSessions: {},
  sessionsDetails: {},
};

export const events = (state = initialState, action: EventsAction): EventsStore => {
  const { payload, type } = action;

  switch (type) {
    /* Events fetching */
    case EventsActionType.FETCH_EVENTS:
      return { ...state, events: { ...state.events, isPending: true } };
    case EventsActionType.FETCH_EVENTS_SUCCESS:
      return { ...state, events: { data: payload.events.data, isPending: false } };
    case EventsActionType.FETCH_EVENTS_ERROR:
      return { ...state, events: { data: [], isPending: false } };

    /* Event properties */
    case EventsActionType.FETCH_EVENT_PROPERTIES:
      return { ...state, properties: { ...state.properties, isPending: true } };
    case EventsActionType.FETCH_EVENT_PROPERTIES_SUCCESS:
      return { ...state, properties: { data: payload.properties, isPending: false } };
    case EventsActionType.FETCH_EVENT_PROPERTIES_ERROR:
      return { ...state, properties: { data: {}, isPending: false } };

    /* Event details fetching */
    case EventsActionType.FETCH_EVENT_DETAILS:
      return {
        ...state,
        eventsDetails: { ...state.eventsDetails, [payload]: { isPending: true } },
      };
    case EventsActionType.FETCH_EVENT_DETAILS_SUCCESS:
      return {
        ...state,
        eventsDetails: {
          ...state.eventsDetails,
          [payload.id]: { isPending: false, data: payload.data },
        },
      };
    case EventsActionType.FETCH_EVENT_DETAILS_ERROR:
      return {
        ...state,
        eventsDetails: { ...state.eventsDetails, [payload]: { isPending: false, data: {} } },
      };

    /* Event titles fetching */
    case EventsActionType.FETCH_EVENT_TITLES:
      return { ...state, eventTitles: { ...state.eventTitles, isPending: true } };
    case EventsActionType.FETCH_EVENT_TITLES_SUCCESS:
      return { ...state, eventTitles: { data: payload, isPending: false } };
    case EventsActionType.FETCH_EVENT_TITLES_ERROR:
      return { ...state, eventTitles: { data: [], isPending: false } };

    /* Event sessions fetching */
    case EventsActionType.FETCH_EVENT_SESSIONS:
      return {
        ...state,
        eventSessions: { ...state.eventSessions, [payload]: { isPending: true } },
      };
    case EventsActionType.FETCH_EVENT_SESSIONS_SUCCESS:
      return {
        ...state,
        eventSessions: {
          ...state.eventSessions,
          [payload.id]: {
            isPending: false,
            data: payload.data.map((item: any) => ({
              id: item.id,
              dateTime: new Date(item.attributes.estimated_started_at * 1000),
            })),
          },
        },
      };
    case EventsActionType.FETCH_EVENT_SESSIONS_ERROR:
      return {
        ...state,
        eventSessions: { ...state.eventSessions, [payload]: { isPending: false, data: {} } },
      };

    /* Session details fetching */
    case EventsActionType.FETCH_SESSION_DETAILS:
      return {
        ...state,
        sessionsDetails: { ...state.sessionsDetails, [payload]: { isPending: true } },
      };
    case EventsActionType.FETCH_SESSION_DETAILS_SUCCESS:
      return {
        ...state,
        sessionsDetails: {
          ...state.sessionsDetails,
          [payload.id]: { isPending: false, data: payload.data },
        },
      };
    case EventsActionType.FETCH_SESSION_DETAILS_ERROR:
      return {
        ...state,
        sessionsDetails: { ...state.sessionsDetails, [payload]: { isPending: false, data: {} } },
      };

    /* Filtering and sorting */
    case EventsActionType.SET_EVENTS_CATEGORY_FILTER:
      return { ...state, filters: { ...state.filters, category: payload } };
    case EventsActionType.SET_EVENTS_TIMELINE_FILTER:
      return { ...state, filters: { ...state.filters, timeline: payload } };
    case EventsActionType.SET_EVENTS_FAVORITES_FILTER:
      return { ...state, filters: { ...state.filters, favourites: payload } };
    case EventsActionType.SET_EVENTS_SORT_DESC:
      return { ...state, sortDesc: payload };

    /* Fallback */
    default:
      return state;
  }
};
